import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import { Collapse, Col } from "react-bootstrap";

import * as userActions from "../../actions/userActions";
import * as departmentActions from "../../actions/departmentActions";
import * as codeActions from "../../actions/codeActions";
import * as roleActions from "../../actions/roleActions";
import * as modalActions from "../../actions/modalActions";
import Modal from "../common/Modal";

import UserForm from "./UserForm";
import HeaderWrapper from "../common/HeaderWrapper";
import UserResourceSummary from "./UserResourceSummary";
import ChangePassForm from "../user-account/ChangePassForm";

const Card = styled.div`
  display: grid;
  grid-template-areas: "checkbox name badge flagged totals icon";
  grid-template-columns: 2fr 1fr 1fr 1fr 4fr auto;
  grid-gap: 25px;
  align-items: center;
  padding: 15px 5px;
  font-family: "Open Sans";
  margin-left: -15px;
  * {
    cursor: pointer;
  }
  &:hover {
    cursor: pointer;
  }
  strong {
    margin: 0;
    letter-spacing: 0 !important;
    grid-area: name;
  }
  .badge {
    margin: 0;
    width: 80px;
    &.success {
      grid-area: badge;
      background: ${(props) => props.theme.green_g} !important;
    }
    &.danger {
      background: ${(props) => props.theme.red_g};
      grid-area: flagged;
    }
  }
  svg {
    grid-area: icon;
  }
  .footer-totals {
    grid-area: totals;
    display: flex;
    justify-content: space-around;
    p {
      font-family: "Open Sans";
      margin-bottom: 0;
    }
  }
`;

class UserEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      formOpened: false
    };
  }

  componentDidMount = () => {
    const { users, roles, departments, match, actions } = this.props;

    actions.getUser(match.params.id);

    if (!roles.length) actions.loadRoles();
    if (!departments.length) actions.loadDepartments();
    actions.loadUserResourceSummary(match.params.id);

    if (!users.length) actions.loadUsers();
  };

  handleSave = (user) => {
    user.id = this.props.user._id;
    this.props.actions.updateUser(user);
  };

  handleEdit = () => {
    this.setState({ editing: !this.state.editing });
  };

  handleCancel = () => {
    this.props.history.goBack();
  };

  handleOpen = () => {
    this.setState({
      formOpened: !this.state.formOpened
    });
  };

  updatePassword = (password) => {
    this.props.actions.hideModal();
    const data = {
      ...this.props.user,
      password
    };
    this.props.actions.updateUser(data, true);
  };

  showPasswordModal = () => {
    this.props.actions.showModal("changePasswordModal");
  };

  render() {
    const {
      user,
      users,
      savingUser,
      roles,
      codes,
      departments,
      isMobile,
      resource_summary,
      auth,
      actions
    } = this.props;
    const { formOpened } = this.state;

    const changePasswordForm = (
      <ChangePassForm
        user={user}
        onSave={this.updatePassword}
        onCancel={actions.hideModal}
      />
    );

    return (
      <React.Fragment>
        <HeaderWrapper
          breadcrumbs={[{ label: "Settings" }, { label: user.full_name }]}
          onClickEdit={this.handleEdit}
          isMobile={isMobile}
          onClickAction={[
            {
              action: () => this.showPasswordModal(),
              text: "Change Password"
            }
          ]}
        />
        {resource_summary?.length ? (
          <div className="content-wrapper">
            <Card open={formOpened} onClick={this.handleOpen}>
              <Col md={12} xs={12}>
                <fieldset>
                  <legend>Resource Summary</legend>
                </fieldset>
              </Col>
              {formOpened ? <IoChevronUp /> : <IoChevronDown />}
            </Card>
            <Collapse in={formOpened}>
              <div>
                <UserResourceSummary
                  isNightMode={auth.isNightMode}
                  resource_summary={resource_summary}
                />
              </div>
            </Collapse>
          </div>
        ) : null}
        <div className="content-wrapper">
          <UserForm
            user={user}
            users={users}
            codes={codes}
            departments={departments}
            roles={roles}
            saving={savingUser}
            editing={this.state.editing}
            onSave={this.handleSave}
            onCancel={this.handleCancel}
          />
        </div>
        <Modal
          id="changePasswordModal"
          title="Change Password"
          body={changePasswordForm}
          close={actions.hideModal}
        />
      </React.Fragment>
    );
  }
}

UserEditPage.propTypes = {
  actions: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  savingUser: PropTypes.bool,
  user: PropTypes.object,
  users: PropTypes.array,
  departments: PropTypes.array,
  codes: PropTypes.array,
  roles: PropTypes.array,
  isMobile: PropTypes.bool,
  match: PropTypes.object,
  history: PropTypes.object,
  resource_summary: PropTypes.array
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    auth: state.reducers.auth,
    savingUser: state.reducers.savingUser,
    user: state.reducers.user,
    users: state.reducers.users,
    departments: state.reducers.departments,
    codes: state.reducers.codes,
    roles: state.reducers.roles,
    resource_summary: state.reducers.resource_summary
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...userActions,
        ...departmentActions,
        ...codeActions,
        ...roleActions,
        ...modalActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(UserEditPage);
